<template>
  <va-modal
    class="flex lg12 xs12 md12"
    v-model="filterConsentsModal"
    :size="cModalSize"
    title="Select Desired Filters"
    hideDefaultActions
    noOutsideDismiss
  >
    
    <va-search
      @pageChanged="submit($event,true)"
      :showTableBody="showTableBody"
      :info="paginationInfo"
    >
      <template v-slot:tableHeaders>
        <th style="width:15%">
          <va-input label="Consent Title" v-model="consentTitle"></va-input>
        </th>

        <th style="width:18%; margin:0% ">
          <va-select
            ref="formSelect"
            id="formElement"
            style="margin-bottom:0rem !important"
            label="Form Title"
            v-model="selectedFormId"
            keyBy="_id"
            textBy="formTitle"
            :options="forms"
          ></va-select>
        </th>

        <th style="width:18%;">
          <va-date-picker
            label="Date From"
            :config="{ dateFormat: 'd/m/Y' }"
            v-model="datepicker.dateFrom"
          />
        </th>
        <th style="width:18%">
          <va-date-picker
            label="Date To"
            :config="{ dateFormat: 'd/m/Y' }"
            v-model="datepicker.dateTo"
          />
        </th>
        <th style="width:15%">
          <va-select
            style="margin-bottom:0%"
            label="Fetch Mode"
            v-model="fetchMode"
            keyBy="id"
            textBy="mode"
            :options="fetchOptions"
          ></va-select>
        </th>

        <th>
          <va-select
            v-model="perPage"
            :label="$t('tables.perPage')"
            :options="perPageOptions"
            keyBy="id"
            textBy="id"
          />
        </th>
      </template>

      <template :v-if="showTableBody" v-slot:tableBody>
        <tr
          class="content"
          style="cursor:pointer"
          @click="goTo(consent)"
          v-for="(consent, index) in filteredConsents"
          :key="index"
        >
          <td>{{ consent.consentTitle }}</td>
          <td>{{ consent.formTitle }}</td>
          <td>{{ consent.createdDate }}</td>
          <td>{{ consent.expiredDate }}</td>
          <td>{{ consent.fetchMode }}</td>
          <td></td>
        </tr>
      </template>
    </va-search>
    <va-button
      style="display:flex"
      class=" flex pull-right"
      @click="submit(false)"
      >Submit</va-button
    >
    <va-button style="display:flex" class="flex pull-right" @click="cancel"
      >Cancel</va-button
    >
  </va-modal>
</template>

<script>
import consentService from "../consentsService.js";
import searchTemplate from "../../../app/SearchTemplate";

export default {
  props: ["filterConsentsModal", "modalSize"],
  data() {
    return {
      consentTitle: null,
      selectedFormId: "",
      formTitle: null,
      fetchMode: "ACTIVE",
      page: 1,
      total: 1,
      pageSize: 1,
      fetchOptions: [
        {
          id: 1,
          mode: "ACTIVE"
        },
        {
          id: 2,
          mode: "INACTIVE"
        },
        {
          id: 3,
          mode: "BOTH"
        }
      ],
      perPage: { id: 10 },
      datepicker: {
        dateFrom: null,
        dateTo: null
      }
    };
  },
  computed: {
    forms() {
      return this.$store.getters.forms;
    },
    consentFilters() {
      return {
        consentTitle: this.consentTitle,
        formId: this.selectedFormId._id,
        dateFrom: this.datepicker.dateFrom,
        dateTo: this.datepicker.dateTo,
        fetchMode: this.fetchMode.mode,
        page: this.page,
        size: this.perPage.id
      };
    },
    paginationInfo() {
      return {
        pageSize: this.pageSize,
        total: this.total,
        resultLength: this.filteredConsents.length
      };
    },
    cModalSize() {
      return this.modalSize;
    },
    showTableBody() {
      return !(this.filteredConsents == null || this.filteredConsents == "");
    },
    filteredConsents() {
      return this.$store.getters.consents;
    },
    perPageOptions() {
      return [{ id: 10 }, { id: 25 }, { id: 50 }];
    }
  },
  methods: {
    submit(page,pageClick) {
      if (!pageClick) {
        this.page = 1;
      }else{
        this.page = page
      }

      consentService.filterConsents(this.consentFilters).then(result => {
        let data = result.data;
        let consents =
          data.filterResults == undefined ? [] : data.filterResults;
        consents.forEach(consent => {
          consent.createdDate = new Date(
            consent.createdDate
          ).toLocaleDateString("en-GB");
        });
        this.total = data.total;
        this.pageSize = data.pageSize;
        this.$store.dispatch("setConsents", consents);
      });
    },
    debug(data) {console.log(data)},
    goTo(data) {
      this.$store.dispatch("setConsent", data);
      this.clearFilters();
      this.$router.push({ name: "editConsent", params: { id: data._id } });
    },
    clearFilters() {
      this.consentTitle = null;
      this.selectedFormId = {};
      this.datepicker.dateFrom = "";
      this.datepicker.dateTo = "";
      this.fetchMode = "";
      this.$store.dispatch("clearConsents");
    },
    cancel() {
      this.clearFilters();
      this.$store.dispatch("clearForms");
      this.$emit("closeModal");
    }
  },
  components: {
    "va-search": searchTemplate
  }
};
</script>

<style scoped>
thead {
  padding: 0%;
}

th {
  padding-left: 0%;
  padding-bottom: 0%;
  vertical-align: bottom;
  border-bottom: 1px;
}

td {
  /* border: 1px solid; */
}

.content tr:hover {
  background-color: darkcyan;
}

.content-padding {
  padding: 10px;
  overflow: hidden; /* minds inside and outside floatting elements, fine if no size given */
}

.content-padding:after {
  content: "";
  display: block; /* or whatever else than inline */
  clear: both;
}

.bottomLine {
  flex-wrap: wrap;
  justify-content: baseline;
  align-content: space-around;
}
</style>
